/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { ShortSellingPosition } from '../models/short-selling-position';
@Injectable({
  providedIn: 'root',
})
class ShortSellingService extends __BaseService {
  static readonly getShortSellingPositionByCompanyIdPath = '/shortInterests/{gvkeyOrC2iq}/chartData';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param gvkeyOrC2iq Id of the company for which short selling positions are required.
   * @return We will have list of positions in which the short selling was done by the given gvkey.
   */
  getShortSellingPositionByCompanyIdResponse(gvkeyOrC2iq: string): __Observable<__StrictHttpResponse<Array<ShortSellingPosition>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/shortInterests/${encodeURIComponent(String(gvkeyOrC2iq))}/chartData`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<ShortSellingPosition>>;
      })
    );
  }
  /**
   * @param gvkeyOrC2iq Id of the company for which short selling positions are required.
   * @return We will have list of positions in which the short selling was done by the given gvkey.
   */
  getShortSellingPositionByCompanyId(gvkeyOrC2iq: string): __Observable<Array<ShortSellingPosition>> {
    return this.getShortSellingPositionByCompanyIdResponse(gvkeyOrC2iq).pipe(
      __map(_r => _r.body as Array<ShortSellingPosition>)
    );
  }
}

module ShortSellingService {
}

export { ShortSellingService }
